<template>
    <div :class="[showType != 'leftList' ? 'student-section' : isCloseLeft ? 'student-section leftList small' : 'student-section leftList']">
      <div class="header-wrap" v-if="showType != 'leftList'">
        <div class="page-title" v-if="studentCount > 0">
          <div class="left-side">
            <span class="icon-jianke"></span>
            <span v-if="!isAgent" class="people-count">{{ $t('studentList.index.018531-0') }}{{studentCount}}{{studentCount > 1 ? $t('studentList.index.018531-21') :$t('studentList.index.018531-1') }}</span>
            <span v-else class="people-count">{{ $t('studentList.index.018531-2') }}{{studentCount}}{{studentCount > 1 ? $t('studentList.index.018531-21') :$t('studentList.index.018531-1') }}</span>
          </div>
          <!-- <ul class="right-side">
            <li>
              <a class="answer-rate" @click="setAnswerRate">
                <span>今日正答率排序</span>
                <span class="caret-wrapper">
                <i :class="['sort-caret ascending', answerRate == 'ascending' ? 'asc-active' : '']" @click.stop="setAnswerRate('ascending')"></i>
                <i :class="['sort-caret descending', answerRate == 'descending' ? 'desc-active' : '']" @click.stop="setAnswerRate('descending')"></i>
                </span>
              </a>
            </li>
            <li>
              <a class="master-rate" @click="setMasterRate">
                <span>今日知识点掌握率排序</span>
                <span class="caret-wrapper">
                <i :class="['sort-caret ascending', masterRate == 'ascending' ? 'asc-active' : '']" @click.stop="setMasterRate('ascending')"></i>
                <i :class="['sort-caret descending', masterRate == 'descending' ? 'desc-active' : '']" @click.stop="setMasterRate('descending')"></i>
              </span>
              </a>
            </li>
            <li class="card-site">
              <span class="split-line"></span>
              <a :class="showType == 'card' ? 'sort-type active' : 'sort-type'" @click="choiceShowType('card')">
                <i class="el-icon-menu"></i>
                <span class="site-name">卡片</span>
              </a>
              <a :class="showType == 'list' ? 'sort-type active' : 'sort-type'" @click="choiceShowType('list')">
                <i class="el-icon-menu"></i>
                <span class="site-name">列表</span>
              </a>
              <span class="split-line"></span>
            </li>
            <li class="card-site question-mask" v-popover:popover>
              <span>{{ $t('studentList.index.018531-10') }}</span>
              <i class="icon-questionMask"></i>
            </li>
          </ul> -->
        </div>
      </div>
      <div class="student-module">
        <!--学生列表-->
        <AllStudent
          ref="allStudent"
          :showType="showType"
          @countStudent="countStudent"
        />
        <!--/.学生列表-->
      </div>
      <!--共性错因的入口-->
      <!-- <WrongEntry v-if="studentCount >= 2" /> -->
      <!--/.共性错因的入口-->
      <!--{{ $t('studentList.index.018531-10') }}-->
      <el-popover
        ref="popover"
        placement="bottom-start"
        trigger="hover"
      >
        <div class="data-description" >
          <div class="basic-definition">
            <div class="module-header-title">
              <span class="color-block"></span>
              <span>{{ $t('studentList.index.018531-3') }}</span>
            </div>
            <ul class="data-text-ul">
              <li>
                <span>{{ $t('studentList.index.018531-4') }}</span>
                <span>{{ $t('studentList.index.018531-5') }}</span>
              </li>
              <li>
                <span>{{ $t('studentList.index.018531-6') }}</span>
                <span>{{ $t('studentList.index.018531-7') }}</span>
              </li>
              <li>
                <span>{{ $t('studentList.index.018531-8') }}</span>
                <span>{{ $t('studentList.index.018531-9') }}</span>
              </li>
            </ul>
          </div>
          <div class="basic-definition data">
            <div class="module-header-title">
              <span class="color-block"></span>
              <span>{{ $t('studentList.index.018531-10') }}</span>
            </div>
            <ul class="data-text-ul">
              <li>
                <span>{{ $t('studentList.index.018531-11') }}</span>
                <span>{{ $t('studentList.index.018531-12') }}</span>
              </li>
              <li>
                <span>{{ $t('studentList.index.018531-13') }}</span>
                <span>{{ $t('studentList.index.018531-14') }}</span>
              </li>
              <li>
                <span>{{ $t('studentList.index.018531-15') }}</span>
                <span> {{ $t('studentList.index.018531-16') }}</span>
              </li>
              <li>
                <span>{{ $t('studentList.index.018531-17') }}</span>
                <span>{{ $t('studentList.index.018531-18') }}</span>
              </li>
              <li>
                <span>{{ $t('studentList.index.018531-19') }}</span>
                <span>{{ $t('studentList.index.018531-20') }}</span>
              </li>
            </ul>
          </div>
        </div>
      </el-popover>
      <!--/.{{ $t('studentList.index.018531-10') }}-->
    </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex';
  import AllStudent from '@/views/studentList/allStudent';
  import WrongEntry from '@/views/wrong/index';
  import Bus from '@/utils/bus.js';
  import { getAuthUserCount } from '@/api/base';
  export default {
    name: "index",
    data () {
      return {
        routerName: "", // 路由名称
        answerRate: '',
        masterRate: '',
        showType: 'list',
        studentCount: 0,
        isAgent: false, // 是否是代理商
        authUserCount: '', // 授权数量
      }
    },
    computed:{
      ...mapGetters(['isCloseLeft']),
    },
    components: {WrongEntry, AllStudent},
    watch: {
      '$route':'getPath'
    },
    mounted: function() {
      let receive = this.$route.params.receive
    let host = window.location.href
    console.log('----rrrr',this.$route)
    console.log('----host',host)
      if (this.$route.path == '/supervise/detail') {
        this.showType = 'leftList';
      } else {
        this.showType = 'list';
      }
      let teacherInfo = JSON.parse(sessionStorage.getItem('TEACHER_INFO'));
      if (teacherInfo.is_agent_school) {
        this.isAgent = teacherInfo.is_agent_school;
        if (this.isAgent) {
          // this.queryAuthUserCount();
        }
      }
    },
    methods: {
      getPath () {
          if (this.$route.path == '/supervise/detail') {
            this.showType = 'leftList';
          } else {
            this.showType = 'list';
          }
      },
      // 设置正答率排序
      setAnswerRate (sort) {
        if (sort == 'ascending' || sort == 'descending') {
          this.answerRate = sort;
        } else {
          this.answerRate = this.answerRate == 'ascending' ? 'descending' : 'ascending';
        }
      },
      // 设置掌握率
      setMasterRate (sort) {
        if (sort == 'ascending' || sort == 'descending') {
          this.masterRate = sort;
        } else {
          this.masterRate = this.masterRate == 'ascending' ? 'descending' : 'ascending';
        }
      },
      choiceShowType (type) {
        this.showType = type;
      },

      countStudent (studentData) {
        this.studentCount = studentData.length;
      },
      computeListClass () {
        console.log('this.showType==='+this.showType)
        if (this.showType != 'leftList') {
          if (this.isCloseLeft) {
            return 'student-section leftList small';
          } else {
            return 'student-section leftList';
          }
        } else {
          return 'student-section';
        }
      },
      queryAuthUserCount() {
        let subjectId = sessionStorage.getItem('subject_id')
        getAuthUserCount({subject_id: subjectId}).then(res => {
          if (res.code == 200) {
            this.authUserCount = res.data.count;
          }
        })
      }
    },
  }
</script>

<style scoped lang="scss">
  .student-section {
    padding: 14px 24px 24px 24px;
    .header-wrap {
      margin-bottom: 16px;
      .page-title {
        display: flex;
        justify-content: space-between;
        height: 34px;
        overflow: hidden;
        .left-side {
          position: relative;
          height: 34px;
          display: flex;
          align-items: center;
          .color-block {
            position: absolute;
            left: 0;
            top: 8px;
            width: 3px;
            height: 16px;
            background: #2980FF;
          }
          .people-count {
            margin-left: 10px;
            font-size: 16px;
            color: #444B65;
            font-weight:600;
          }
        }
        .right-side {
          li {
            float: left;
            .answer-rate {
              cursor: pointer;
              user-select: none;
            }
            .master-rate {
              cursor: pointer;
              user-select: none;
            }
            .caret-wrapper {
              position: relative;
              display: inline-flex;
              flex-direction: column;
              align-items: center;
              height: 34px;
              width: 24px;
              vertical-align: middle;
              cursor: pointer;
              overflow: initial;
              .sort-caret {
                width: 0;
                height: 0;
                border: 5px solid transparent;
                position: absolute;
                left: 7px;
                &.ascending {
                  border-bottom-color: #c0c4cc;
                  top: 5px;
                }
                &.descending {
                  border-top-color: #c0c4cc;
                  bottom: 7px;
                }
                &.asc-active {
                  border-bottom-color: #2980FF;
                }
                &.desc-active {
                  border-top-color: #2980FF;
                }
              }
            }
            &.card-site {
              display: flex;
              height: 34px;
              justify-content: center;
              align-items: center;
              margin-top: -1px;
              margin-left: 40px;
              .sort-type {
                cursor: pointer;
                margin-right: 20px;
                &.active {
                  color: #2980FF;
                }
              }
              .split-line {
                width: 2px;
                height: 16px;
                margin-right: 20px;
                background-color: #E4EFF6;
                display: inline-block;
              }
              .site-name {
                /*padding-right: 20px;*/
              }
              &.question-mask {
                cursor: pointer;
              }
            }
          }
        }
      }
    }
    .student-module {
      // width: 1318px;
    }
    &.leftList {
      position: fixed;
      width: 270px;
      height: 100%;
      top: 48px;
      background: rgba(255,255,255,1);
      box-shadow: 0px 6px 12px 0px rgba(68,75,101,0.06);
      padding: 0;
      overflow-y: auto;
    }
    &.small {
      position: fixed;
      width: 119px;
      height: 100%;
      top: 48px;
      background: rgba(255,255,255,1);
      box-shadow: 0px 6px 12px 0px rgba(68,75,101,0.06);
      padding: 0;
      overflow-y: auto;
    }
  }
</style>


// WEBPACK FOOTER //
// src/views/studentList/index.vue